<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import Field from './Field.svelte';
    export let fields = [];
    export let data = {};
    export let errors = {};

    /*
    if (!data) {
        data = {};
        for (let field of fields) {
            data[field.name] = undefined;
        }
    }
    */

    let dispatch = createEventDispatcher()

    const handleSubmit = () => dispatch("submit", data);
    const handleDelete = () => dispatch("delete", data);
</script>

<form on:submit|preventDefault={handleSubmit}>
    {#each fields as field}
        {#if !(field.type == "hidden")}
        <Field {...field} bind:value={data[field.name]} {errors} />
        {/if}
    {/each}

    {#if data.id}
    <div class="buttons is-pulled-left">
        <span class="button is-danger" on:click={handleDelete}>Delete</span>
    </div>
    {/if}
    <div class="buttons is-right">
        <button class="button is-primary">Save</button>
    </div>
</form>